// a reducer takes in two things
// 1. the action (info about what happened)
// 2. copy of current state

import * as types from '../constants/actionTypes';
import { createNewMessage } from '../constants/factory';

export default function requests(state = [], action) {
    const addNewMessage = () => {
        console.log('Reducer:  Adding New Message');
        console.log(state, action);

        var i = state.findIndex((request) => {
            return request.requestInfo.requestId === action.requestId;
        });

        return [
            ...state.slice(0, i),
            {
                ...state[i],
                requestInfo: {
                    ...state[i].requestInfo,
                    messages: [
                        ...state[i].requestInfo.messages,
                        createNewMessage(action.user, action.text, action.currentDate)
                    ]
                }
            },
            ...state.slice(i + 1)
        ];
    };

    const addNewRequest = () => {
        console.log('Reducer:  Adding New Request');
        console.log(state, action);

        return [
        ...state,
            action.newRequest
        ];
    };

    const approveRequest = () => {
        console.log('Reducer:  Approving Request');
        console.log(state, action);

        // return [
        //     ...state,
        //     action.newRequest
        // ];

        return state;
    };

    const rejectRequest = () => {
        console.log('Reducer:  Rejecting Request');
        console.log(state, action);

        // return [
        //     ...state,
        //     action.newRequest
        // ];
        return state;
    };

    // contains all acceptable actions
    const acceptedActions = {
        [types.ADD_NEW_MESSAGE]: addNewMessage,
        [types.ADD_NEW_REQUEST]: addNewRequest,
        [types.APPROVE_REQUEST]: approveRequest,
        [types.REJECT_REQUEST]: rejectRequest,
    };

    // return state as it was if no accepted action
    if (typeof acceptedActions[action.type] === 'undefined') {
        return state;
    }

    // run state change code
    return acceptedActions[action.type]();
}



/** WEBPACK FOOTER **
 ** ./src/reducers/requests.js
 **/